<script setup lang="ts" name="BillOfLadingCard">
import CustomCard from '~/components/CustomCard.vue';

const { title, tooltipDescription, tooltipTitle } = defineProps<{
  title: string;
  tooltipTitle?: string;
  tooltipDescription?: string;
}>();
</script>

<template>
  <CustomCard
    :title="title"
    :tooltip="tooltipDescription"
    :tooltipTitle="tooltipTitle"
  >
    <div class="mx-6 mb-6 h-full">
      <slot />
    </div>
  </CustomCard>
</template>
